export const getStoreUrl = "/store";
